import { NgModule, ModuleWithProviders } from '@angular/core';

import { SharedModule } from '@mem-shared/shared.module';
// import { MegaMenuModule } from './mega-menu/mega-menu.module';
import { GoogleAnalyticsModule } from './google-analytics/google-analytics.module';
import { BreadcrumbsModule } from './breadcrumb/breadcrumbs.module';
import { BreadcrumbsService } from './breadcrumb/breadcrumbs.service';
import { FooterComponent } from './footer/footer.component';
import { FooterService } from './footer/footer.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GuidInterceptor } from 'app/core/footer/guid-interceptor';
// import { MessageCenterService } from '../message-center/message-center.service';
// import { DisclaimerComponent } from './disclaimer/disclaimer.component';
// import { DisclaimerService } from './disclaimer/disclaimer.service';
// import { PromoBannerComponent } from './promo-banner/promo-banner.component';
// import { RedirectModule } from './redirect/redirect.module';
import { GoogleAnalyticsService } from './google-analytics/google-analytics.service';
// import { FeedbackLinkComponent } from './feedback-link/feedback-link.component';

/**
 * Core Module
 * Core module will contain all of the modules that are only included in the
 * root app component And not included in any child modules.
 */
@NgModule({
  imports: [SharedModule, GoogleAnalyticsModule, BreadcrumbsModule],
  exports: [ GoogleAnalyticsModule, BreadcrumbsModule,FooterComponent],
  providers: [
    FooterService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GuidInterceptor,
      multi: true
    },
    BreadcrumbsService,
    {provide : 'parentGoogleAnalyticsService', useExisting: GoogleAnalyticsService},
    GoogleAnalyticsService
  ],
  declarations: [FooterComponent]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts